/* eslint-disable no-unused-vars */
/* eslint-disable no-await-in-loop */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Button, Form, InputNumber, message, Modal, Select, Typography, Upload } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import moment from 'moment';

import { UploadOutlined } from '@ant-design/icons';

import { api } from '../../Services/axiosService';
import { buildFinalFileList, deleteRemovedFiles, processFileUploads } from '../../Utils/fileUtils';
import { generateAndFormatPatchOperations } from '../../Utils/patchUtils';
import TaskCommentFunctions from '../Schedule/TaskCommentFunctions';

const { Text } = Typography;

export default function ModalTrainingConclusion({
  currentOpenTask,
  loading,
  setShowConclusionModal,
  eventSource,
  reasonsOptions,
  finishMargin,
  stages,
  onTaskUpdated,
  setIsTaskDrawerVisible,
}) {
  const [form] = Form.useForm();
  const [loadingModal, setLoadingModal] = useState(false);
  const [showFinishMarginReason, setShowFinishMarginReason] = useState(false);
  const [attendanceList, setAttendanceList] = useState([]);
  const [originalFiles, setOriginalFiles] = useState([]);
  const [addedFiles, setAddedFiles] = useState([]);
  const [removedFiles, setRemovedFiles] = useState([]);
  const [originalTaskData, setOriginalTaskData] = useState(null);

  const source = eventSource.toLowerCase();
  const isInstructor = source.includes('instructor');
  const isDriver = source.includes('driver');

  // Valida se a lista de presença é obrigatória
  const requiresAttendanceList = originalFiles.length === 0 && isInstructor;
  const hasFilesToSubmit = attendanceList.length > 0 || addedFiles.length > 0;

  // Exibe inputs de quantidade apenas se não preenchidos
  const showQtyStudentsTrainedField =
    isInstructor &&
    (!currentOpenTask?.qtyStudentsTrained || currentOpenTask?.qtyStudentsTrained <= 0);

  const showQtyStudentsTransportedField =
    isDriver &&
    (!currentOpenTask?.qtyStudentsTransported || currentOpenTask?.qtyStudentsTransported <= 0);

  useEffect(() => {
    if (currentOpenTask) {
      const taskCopy = JSON.parse(JSON.stringify(currentOpenTask));
      setOriginalTaskData(taskCopy);
      setAttendanceList(taskCopy.finalAttendanceDocList || []);
      setOriginalFiles(taskCopy.finalAttendanceDocList || []);
    } else {
      setOriginalTaskData(null);
      setAttendanceList([]);
      setOriginalFiles([]);
    }
    setAddedFiles([]);
    setRemovedFiles([]);
  }, [currentOpenTask]);

  const generateConclusionPatch = (original, updated, driverListIndex = -1) => {
    const operations = [];
    const { scheduleType } = updated;

    // Compara finalAttendanceDocList
    if (
      JSON.stringify(original.finalAttendanceDocList) !==
      JSON.stringify(updated.finalAttendanceDocList)
    ) {
      operations.push({
        op: 'replace',
        path: '/finalAttendanceDocList',
        value: updated.finalAttendanceDocList,
      });
    }

    // Compara e atualiza qtyStudentsTrained
    if (
      scheduleType !== 'driver' &&
      original.qtyStudentsTrained !== updated.qtyStudentsTrained &&
      updated.qtyStudentsTrained
    ) {
      operations.push({
        op: 'replace',
        path: '/qtyStudentsTrained',
        value: updated.qtyStudentsTrained,
      });
    }

    // Compara e atualiza qtyStudentsTransported
    if (
      scheduleType === 'driver' &&
      original.qtyStudentsTransported !== updated.qtyStudentsTransported &&
      updated.qtyStudentsTransported
    ) {
      operations.push({
        op: 'replace',
        path: '/qtyStudentsTransported',
        value: updated.qtyStudentsTransported,
      });
    }

    // Atualiza stage
    if (scheduleType === 'driver' && driverListIndex !== -1) {
      operations.push({
        op: 'replace',
        path: `/driverList/${driverListIndex}/stage`,
        value: updated.driverList[driverListIndex].stage,
      });
    } else if (scheduleType !== 'driver') {
      operations.push({
        op: 'replace',
        path: `/${scheduleType}/stage`,
        value: updated[scheduleType].stage,
      });
    }

    return operations;
  };

  const submit = async (values) => {
    try {
      if (requiresAttendanceList && !hasFilesToSubmit) {
        message.error('É obrigatório enviar pelo menos um arquivo da Lista de Presença Final!');
        return;
      }

      const finishedTaskstage = stages?.find(({ id }) => id === 5);
      const dateEndDateTraning = moment(new Date(originalTaskData.endDate)).subtract(
        finishMargin,
        'minutes'
      );
      const dateUTC = moment(dateEndDateTraning).add(3, 'hour');

      if (
        moment(new Date(originalTaskData.endDate)).diff(moment(new Date()).utc(-3), 'seconds') >
          finishMargin * 60 &&
        !values.reasonFinishMargin
      ) {
        setShowFinishMarginReason(true);
        message.error(
          `Você está concluindo o Treinamento antes do prazo aceitável (${moment(dateUTC).format(
            'HH:mm:ss'
          )}min), preencha o motivo!`
        );
        return;
      }

      setLoadingModal(true);

      const updatedTaskData = JSON.parse(JSON.stringify(originalTaskData));

      if (values?.qtyStudentsTrained) {
        updatedTaskData.qtyStudentsTrained = parseInt(values.qtyStudentsTrained, 10 || 0);
      }

      if (values?.qtyStudentsTransported) {
        updatedTaskData.qtyStudentsTransported = parseInt(values.qtyStudentsTransported, 10 || 0);
      }

      // Upload de novos arquivos e exclusão de arquivos removidos
      if (addedFiles.length > 0) {
        const uploadedFiles = await processFileUploads(
          addedFiles,
          'trainings',
          updatedTaskData.id,
          'finalAttendanceDocList'
        );
        updatedTaskData.finalAttendanceDocList = buildFinalFileList(
          originalFiles,
          removedFiles,
          uploadedFiles
        );
      }
      await deleteRemovedFiles(removedFiles);

      // Adiciona comentários de atividade
      if (showFinishMarginReason && values.reasonFinishMargin) {
        await TaskCommentFunctions.addTaskComment(
          updatedTaskData,
          'TaskFinishedBeforeMargin',
          eventSource,
          values.descriptionFinishMargin,
          values.reasonFinishMargin?.value,
          values.reasonFinishMargin?.label
        );
      } else {
        await TaskCommentFunctions.addTaskComment(
          updatedTaskData,
          'TaskFinished',
          eventSource,
          values.descriptionReason,
          null,
          null
        );
      }

      // Atualiza o estágio do agendamento
      const { scheduleType } = updatedTaskData;
      let driverIndex = -1;
      if (scheduleType === 'driver') {
        const driverUserId = parseInt(
          JSON.parse(localStorage.getItem('conecta__userData'))?.id,
          10
        );
        driverIndex = updatedTaskData.driverList?.findIndex(
          ({ userId }) => userId === driverUserId
        );
        if (driverIndex !== -1 && finishedTaskstage) {
          updatedTaskData.driverList[driverIndex].stage = finishedTaskstage;
        }
      } else if (scheduleType && updatedTaskData[scheduleType] && finishedTaskstage) {
        updatedTaskData[scheduleType].stage = finishedTaskstage;
      }

      // Gera e envia o patch
      const operations = generateConclusionPatch(originalTaskData, updatedTaskData, driverIndex);
      if (operations.length > 0) {
        await api.patch(`/Task/${updatedTaskData.id}`, operations);
      }

      // Limpa e fecha o modal
      setShowFinishMarginReason(false);
      setShowConclusionModal(false);
      form.resetFields();
      message.success('Treinamento Atualizado!');

      if (onTaskUpdated) {
        onTaskUpdated(updatedTaskData);
      }
      setIsTaskDrawerVisible(false);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
      message.error('Erro ao atualizar o Treinamento!');
    } finally {
      setLoadingModal(false);
    }
  };

  const handleFileChange = ({ file, fileList }) => {
    // Atualiza a lista de arquivos para exibição
    const newFileList = fileList.map((f) => ({
      ...f,
      label: f.name,
      name: f.name,
      url: f.url,
      originFileObj: f.originFileObj,
      isNew: !f.url,
    }));
    setAttendanceList(newFileList);

    // Adiciona o novo arquivo à lista de 'addedFiles'
    if (file.status !== 'removed' && !file.url) {
      const newFile = {
        uid: file.uid,
        name: file.name,
        label: file.name,
        originFileObj: file, // Preserva o objeto do arquivo original
        isNew: true,
      };
      setAddedFiles((prev) => [...prev.filter((f) => f.uid !== file.uid), newFile]);
    }

    // Gerencia a remoção de arquivos
    if (file.status === 'removed') {
      if (file.url && !file.isNew) {
        // Arquivo original removido
        setRemovedFiles((prev) => [
          ...prev,
          { url: file.url, name: file.name, taskId: currentOpenTask?.id },
        ]);
      } else if (file.isNew) {
        // Arquivo recém-adicionado e depois removido
        setAddedFiles((prev) => prev.filter((f) => f.uid !== file.uid));
      }
    }
  };

  return (
    <Modal
      className="modal-Training-Complet"
      title="Concluir Treinamento"
      open={true}
      onCancel={() => setShowConclusionModal(false)}
      cancelText="Fechar"
      maskClosable={false}
      footer={[
        <Button onClick={() => setShowConclusionModal(false)}>Fechar</Button>,
        <Button
          form="modalConclusion"
          key="submit"
          htmlType="submit"
          style={{
            backgroundColor: '#87CEEB',
            color: '#121212',
            border: 'none',
            opacity: loading || loadingModal ? 0.3 : 1,
          }}
          loading={loading || loadingModal}
        >
          Concluir
        </Button>,
      ]}
    >
      <Form
        form={form}
        name="modalConclusion"
        layout="vertical"
        autoComplete="off"
        onFinish={submit}
        preserve={false}
      >
        <div style={{ marginBottom: 16, textAlign: 'center' }}>
          <Text type="danger">
            Após concluir o treinamento, não será possível alterar nenhuma informação. Confirme se
            todos os dados estão corretos antes de prosseguir.
          </Text>
        </div>

        <Form.Item label="Observações" name="descriptionReason">
          <TextArea rows={6} />
        </Form.Item>

        {showFinishMarginReason && (
          <>
            <h3 style={{ marginTop: 48 }}>Motivo conclusão antecipada</h3>
            <Form.Item
              label="Motivo"
              name="reasonFinishMargin"
              rules={[{ required: true, message: 'Campo obrigatório!' }]}
            >
              <Select
                disabled={loading}
                placeholder="Selecione"
                optionFilterProp="label"
                dropdownStyle={{ borderRadius: 16 }}
                options={reasonsOptions}
              />
            </Form.Item>
            <Form.Item label="Observações" name="descriptionFinishMargin">
              <TextArea rows={6} disabled={loading} />
            </Form.Item>
          </>
        )}

        {showQtyStudentsTrainedField && (
          <Form.Item
            label="Quantidade Alunos Treinados"
            name="qtyStudentsTrained"
            rules={[{ required: true, message: 'Campo obrigatório!' }]}
          >
            <InputNumber placeholder="0" min={0} max={currentOpenTask?.qtyStudentsPerClass} />
          </Form.Item>
        )}

        {showQtyStudentsTransportedField && (
          <Form.Item
            label="Quantidade Alunos Transportados"
            name="qtyStudentsTransported"
            rules={[{ required: true, message: 'Campo obrigatório!' }]}
          >
            <InputNumber placeholder="0" min={0} max={currentOpenTask?.qtyStudentsPerClass} />
          </Form.Item>
        )}

        {requiresAttendanceList && (
          <Form.Item
            label="Lista de Presença Final"
            name="finalAttendanceDocList"
            rules={[{ required: !hasFilesToSubmit, message: 'Campo obrigatório!' }]}
          >
            <Upload
              beforeUpload={() => false}
              multiple
              disabled={loading || loadingModal}
              fileList={attendanceList.map((f, index) => ({
                uid: f.url || f.uid || `${index}`,
                name: f.label || f.name,
                status: 'done',
                url: f.url,
                originFileObj: f.originFileObj,
              }))}
              onChange={handleFileChange}
            >
              <Button icon={<UploadOutlined />}>Enviar arquivos</Button>
            </Upload>
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
}
